import script from "./ListingBlockLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListingBlockLayout.vue?vue&type=script&setup=true&lang=ts"

import "./ListingBlockLayout.vue?vue&type=style&index=0&id=18c6801a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18c6801a"]])

export default __exports__